import SmoothScroll from "smooth-scroll"

let offset = 0

let path = window.location.pathname

if (window.innerWidth > 1024 && (path == "/koshu/" || path == "/syashu/")) {
    // offset = window.innerWidth * 0.09663250366
    offset = window.innerHeight * 0.2
}

let smoption = {
    updateURL: false,
    speed: 300,
    offset: offset,
}

let scroll = new SmoothScroll('a[href*="#"]', smoption);